import { render, staticRenderFns } from "./EmployerSelector.vue?vue&type=template&id=38422f64&"
import script from "./EmployerSelector.vue?vue&type=script&lang=ts&"
export * from "./EmployerSelector.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports